import React from 'react';

const FormField = ({id,formData,change}) => {
    
    const showError = (search) => {
       
        let errorMessage = null;
        
         if(formData.validation && !formData.valid){
            errorMessage = (
                <p className="small text-warning">
                    {formData.validationMessage}
                </p>
            )
         }
         if(search === "search"){
             errorMessage = null;
         }
        
         return errorMessage;
    }
    const renderTemplate = () => {
        let formTemplate = null;
        switch (formData.element) {
            case ('input'):
                formTemplate = (
                    <div className="formBlock">
                        {formData.showlabel ? 
                            <div className='label_inputs'>{formData.config.label}</div>
                        :null}
                        <div>
                            <input 
                                className="form-control"
                                aria-label="Search"
                                {...formData.config}
                                value = {formData.value}
                                onBlur = {(event) => change({event,id,blur:true})}
                                onChange = {(event) => change({event,id})}
                            />
                            {formData.config.name === "search_input" ? showError("search") : showError()}
                        </div>
                    </div>
                )
                break;
            case ('number'):
                    formTemplate = (
                        <div className="formBlock">
                            <input 
                                value = {formData.value}
                                onBlur = {(event) => change({event,id,blur:true})}
                                onChange = {(event) => change({event,id})}
                            />
                            {showError()}
                        </div>
                    )
                    break;
            case ('date'):
                formTemplate = (
                    <div className="formBlock">
                        <input 
                            value = {formData.value}
                            onBlur = {(event) => change({event,id,blur:true})}
                            onChange = {(event) => change({event,id})}
                        />
                        {showError()}
                    </div>
                )
                break;
            case ('textarea') :
                formTemplate = (
                    <div className="formBlock">
                        {formData.showlabel ? 
                            <div className='label_inputs'>{formData.config.label}</div>
                        :null}
                       <textarea   
                        {...formData.config}
                            value = {formData.value} 
                            onBlur = {(event) => change({event,id,blur:true})}
                            onChange = {(event) => change({event,id})}
                        />
                        {showError()}
                    </div>
                )
                break;
            case ('select') :
                formTemplate = (
                    <div className="formBlock">
                        {formData.showlabel ? 
                            <div className='label_inputs'>{formData.config.label}</div>
                        :null}
                       <select   
                            value = {formData.value} 
                            onBlur = {(event) => change({event,id,blur:true})}
                            onChange = {(event) => change({event,id})}
                            style={{ width: "100%", padding: "1.7%" }}
                        >
                            <option value=''>Loại sản phẩm...</option>
                            {
                                formData.config.options.map(item => (
                                    <option key={item.value} value={item.value} >
                                        {item.label}
                                    </option>
                                )) 
                            }
                        </select>
                        {showError()}
                    </div>
                )
                break;
            default:
                formTemplate = null
                break;
        }
        return formTemplate;
    }
    return (
        <div>
            {renderTemplate()}
        </div>
    );
};

export default FormField;